import request from '@/utils/request'

// 获取产品分类列表
export function getProductCategories() {
  return request({
    url: '/website/productcategory/active/list',
    method: 'get'
  })
}

// 获取产品列表
export function getProducts(params) {
  return request({
    url: '/website/product/active/list',
    method: 'get',
    params
  })
}

// 根据分类ID获取产品列表
export function getProductsByCategory(categoryId) {
  return request({
    url: `/website/product/category/${categoryId}`,
    method: 'get'
  })
}

// 获取产品详情
export function getProductDetail(productId) {
  return request({
    url: `/website/product/detail/${productId}`,
    method: 'get'
  })
}

// 提交预约
export function submitBooking(data) {
  return request({
    url: '/website/productbooking',
    method: 'post',
    data
  })
}
